export default "__VITE_ASSET__Fc8wRMYh__";